import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Checkbox } from './ui/checkbox';
import { toast } from 'sonner';
import { Star, Loader2, BellRing } from 'lucide-react';

const FUELS = [{ key: 'gasoleo', label: 'Gasóleo' }, { key: 'gasolina', label: 'Gasolina' }];

export const FuelFavoriteButton = ({ station, favorite, api, onChange }) => {
  const [open, setOpen] = useState(false);
  const [types, setTypes] = useState(favorite?.fuel_types || ['gasoleo', 'gasolina']);
  const [saving, setSaving] = useState(false);

  const toggle = (key) => setTypes(t => (t.includes(key) ? t.filter(k => k !== key) : [...t, key]));

  const save = async () => {
    setSaving(true);
    try {
      const res = await api().put(`/fuel/favorites/${station.id}`, { fuel_types: types });
      onChange(station.id, res.data);
      toast.success('Alerta activado para ' + station.name);
      setOpen(false);
    } catch (err) {
      toast.error(err.response?.status === 401 ? 'Inicie sessão para activar alertas' : (err.response?.data?.detail || 'Erro ao guardar alerta'));
    }
    setSaving(false);
  };

  const remove = async () => {
    setSaving(true);
    try {
      await api().delete(`/fuel/favorites/${station.id}`);
      onChange(station.id, null);
      toast.success('Alerta removido');
      setOpen(false);
    } catch (err) {
      toast.error('Erro ao remover alerta');
    }
    setSaving(false);
  };

  return (
    <>
      <button onClick={() => { setTypes(favorite?.fuel_types || ['gasoleo', 'gasolina']); setOpen(true); }}
        aria-label="Seguir estação"
        className={`w-11 h-11 rounded-lg flex items-center justify-center transition-colors ${favorite ? 'bg-yellow-100 text-yellow-500' : 'bg-zinc-100 text-zinc-400 hover:text-yellow-500'}`}
        data-testid={`fuel-favorite-btn-${station.id}`}>
        <Star className={`w-5 h-5 ${favorite ? 'fill-current' : ''}`} />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="w-[calc(100%-2rem)] max-w-sm rounded-2xl" data-testid="fuel-favorite-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><BellRing className="w-5 h-5 text-sonangol-orange" />Alerta de combustível</DialogTitle>
            <DialogDescription>Receba uma notificação quando o combustível voltar à {station.name}.</DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            {FUELS.map(f => (
              <label key={f.key} className="flex items-center gap-3 p-3 rounded-xl border border-zinc-200 cursor-pointer min-h-[48px]">
                <Checkbox checked={types.includes(f.key)} onCheckedChange={() => toggle(f.key)} data-testid={`fuel-favorite-${f.key}`} />
                <span className="font-medium text-zinc-800">{f.label}</span>
              </label>
            ))}
          </div>
          <div className="flex gap-2 pt-2">
            {favorite && (
              <Button variant="outline" onClick={remove} disabled={saving} className="flex-1 h-11" data-testid="fuel-favorite-remove-btn">Remover</Button>
            )}
            <Button onClick={save} disabled={saving || !types.length} className="flex-1 h-11 bg-sonangol-orange hover:bg-orange-600 text-white" data-testid="fuel-favorite-save-btn">
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Guardar alerta'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FuelFavoriteButton;
